import React, { ReactNode } from 'react';
import { Box, Typography } from '@p81-common/ui';
import { createNeutralInfoBoxClasses } from './styles';

interface NeutralInfoBoxProps {
  title: string;
  children?: ReactNode;
}

// Plain light-blue information box (no icon), per the Figma spec for the
// confirm-step actions list and the parent-workspace warning.
const NeutralInfoBox = ({ title, children }: NeutralInfoBoxProps) => {
  const classes = createNeutralInfoBoxClasses();

  return (
    <Box className={classes.box}>
      <Typography variant="body2" className={classes.title}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default NeutralInfoBox;
